<template>
  <div class="h-container">
<div class="h-box layoutMaxWidth">
    <div class="h-box-left">
      <img src="@/assets/img/logo.png" alt />
      <img src="@/assets/img/name@2x.png" alt />
    </div>
    <ul>
      <li :class="{'active':activeIndex==0}" @click="handleClick(0)">首页</li>
      <li :class="{'active':activeIndex==1}" @click="handleClick(1)">关于我们</li>
      <li :class="{'active':activeIndex==2}" @click="handleClick(2)">产品介绍</li>
      <li :class="{'active':activeIndex==3}" @click="handleClick(3)">商务合作</li>
      <li :class="{'active':activeIndex==5}" @click="goToPage(5)">商务洽谈</li>
      <li :class="{'active':activeIndex==4}" @click="handleClick(4)">联系我们</li>
    </ul>
  </div>
  </div>
  
</template>
<script>
export default {
  data() {
    return {
      decsTop: 0,
      proTop: 0,
      appliTop: 0,
      footerTop: 0,
      activeIndex: 0,
      scroArr: []
    };
  },
  watch: {
    "$route.name"(val, oldVal) {
      console.log(val, oldVal);
      if (val !== "home") {
        if(val == 'negotiation'){
          this.activeIndex = 5;
        }else{
          this.activeIndex = 2;
        }
       
      } else {
        this.activeIndex = 0;
      }
    }
  },
  methods: {
    handleClick(index) {
      if (this.$route.name == "home") {
        this.activeIndex = index;
        $("#app").scrollTop(this.scroArr[index]);
      } else {
        this.$router.push({ name: "home"});
        // this.$emit('activeIndex',index)
        setTimeout(() => {
          this.handleClick(index);
        }, 200);
        
      }
    },
    goToPage(index){
      this.activeIndex = index;
      this.$router.push({ name: "negotiation"});
    }
  },
  mounted() {
    if (this.$route.name == "home") {
      [this.decsTop, this.proTop, this.appliTop, this.footerTop] = [
        $("#decs")[0].offsetTop,
        $("#pro")[0].offsetTop,
        $("#appli")[0].offsetTop,
        $("#footer")[0].offsetTop
      ];
      console.log(this.decsTop, this.proTop, this.appliTop, this.footerTop);
      this.scroArr = [
        0,
        this.decsTop -62,
        this.proTop -62 ,
        this.appliTop -62,
        this.footerTop -62
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.h-container{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 99999;
}
.h-box {
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  height: 62px;
  box-sizing: border-box;
  max-width: 1200px;
  
  &-left {
    img:first-child {
      width: 22px;
      height: 22px;
    }
    img:last-child {
      width: 27px;
      height: 21px;
      margin-left: 4px;
    }
  }
  ul {
    display: flex;
    width: 50%;
    justify-content: space-between;
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .active {
      color: $primary-color;
    }
    .active::after {
      content: "";
      display: inline-block;
      height: 1px;
      width: 9px;
      background-color: $primary-color;
      margin-top: 5px;
    }
    li::after {
      content: "";
      display: inline-block;
      height: 1px;
      width: 20px;
      background-color: white;
      margin-top: 5px;
    }
  }
}
</style>